import { memo } from "react";
import MessageContent from "./messageContent";
import { formatMessageTime, getAgentLabel, getStatusIcon } from "../../../function/CustomFunction";

function Outgoing({ chat }) {
  // Safely convert message_deliver to string; default to "0" if undefined
  const deliverStatus = chat.message_deliver != null ? chat.message_deliver.toString() : "0";

  return (
    <div className="d-flex chat chat-end px-2 px-md-3 px-lg-4 my-1 justify-content-end">
      <div
        className="shadow-sm px-3 py-2 chat-bubble outgoing"
        style={{
          position: "relative",
          maxWidth: "50%",
          backgroundColor: "#DCF8C6",
          color: "#111B21",
          borderRadius: "12px",
          borderBottomRightRadius: "2px",
          userSelect: "text",
          transition: "background-color 0.2s ease",
          minWidth: "100px",
        }}
      >
        <div
          className="agent-label"
          style={{
            fontSize: "10px",
            color: "#667781",
            fontWeight: "500",
            letterSpacing: "0.3px",
            textTransform: "uppercase",
          }}
        >
          {getAgentLabel(chat.agent_id)}
        </div>

        <div className="mb-3">
          <MessageContent chat={chat} sending_type="outgoing" />
        </div>

        <div
          className="d-flex align-items-center"
          style={{ position: "absolute", bottom: "4px", right: "15px", zIndex: 10 }}
        >
          <small className="text-muted me-1" style={{ fontSize: "0.7rem" }}>
            {formatMessageTime(chat.date, chat.time)}
          </small>
          {getStatusIcon(deliverStatus)}
        </div>
      </div>
    </div>
  );
}

export default memo(Outgoing);
